import React from 'react';
import {BsDoorOpen, BsCheck2Square} from "react-icons/bs";

const InteriorDetail = ({...props}) => {
    const interiorCont = props.interiorContent;
    
    return (
        <>{interiorCont &&
        <div className='flex flex-col mb-4'>
            <h3 className='font-semibold text-lg text-gray-800 underline mb-2 uppercase flex items-center space-x-2'><BsDoorOpen /> <span>Interior Detail</span></h3>
            <div dangerouslySetInnerHTML={{ __html: interiorCont }}></div>
        </div>
        }</>
    );
}

export default InteriorDetail;
